import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['badge', 'input'];

  static values = {
    states: Array,
    index: { type: Number, default: 0 },
  };

  toggle() {
    if (this.statesValue.length === 0) return;
    this.indexValue = (this.indexValue + 1) % this.statesValue.length;
  }

  indexValueChanged() {
    const state = this.statesValue[this.indexValue];
    if (!state) return;

    this.badgeTarget.textContent = state.label;
    this.badgeTarget.className = `ui-text-badge ui-text-badge--${state.variant}`;
    this.badgeTarget.setAttribute('aria-pressed', this.indexValue > 0 ? 'true' : 'false');
    if (this.hasInputTarget) this.inputTarget.value = state.value;
  }
}
